module.exports = __webpack_public_path__ + "assets/img/slogan-83a62bf1.png";